import { render, staticRenderFns } from "./AdminLoginForm.vue?vue&type=template&id=22c7c4d2&scoped=true&"
import script from "./AdminLoginForm.vue?vue&type=script&lang=js&"
export * from "./AdminLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminLoginForm.vue?vue&type=style&index=0&id=22c7c4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c7c4d2",
  null
  
)

export default component.exports